export default __webpack_public_path__ + "static/media/chat4.0a4ae0bf.png";